import React from "react";

import IconGridItem from "./IconGridItem";

export const formatDataAsGridContent = ({ iconData }) => {
    return iconData.map(icon => (
        <IconGridItem
            key={icon.id}
            iconId={icon.id}
            iconTerm={icon.term}
            iconPreviewUrl={icon.thumbnail}
            iconSlugWithId={icon.slugWithId}
        />
    ));
};
